import React from 'react';

function Inprint() {
    return (
        <div className="inprint-page">
            <div className="page-title">
                <div className="container">
                    <h1>Imprint</h1>
                </div>
            </div>
            
            <section className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto">
                            <div className="inprint-content">
                                <h2>Information according to § 5 TMG</h2>
                                <p>
                                    <strong>Website Owner:</strong><br />
                                    My Knowledge Portal<br />
                                    [Your Company Name]<br />
                                    [Street Address]<br />
                                    [Postal Code] [City]<br />
                                    [Country]
                                </p>

                                <h2>Contact</h2>
                                <p>
                                    <strong>Phone:</strong> [Your Phone Number]<br />
                                    <strong>Email:</strong> <a href="mailto:contact@example.com">contact@example.com</a><br />
                                    <strong>Website:</strong> <a href="https://www.example.com">www.example.com</a>
                                </p>

                                <h2>Responsible for content according to § 55 Abs. 2 RStV</h2>
                                <p>
                                    [Your Name]<br />
                                    [Street Address]<br />
                                    [Postal Code] [City]<br />
                                    [Country]
                                </p>

                                <h2>VAT ID</h2>
                                <p>
                                    Sales tax identification number according to § 27 a of the Sales Tax Law:<br />
                                    [Your VAT ID Number]
                                </p>

                                <h2>Disclaimer</h2>
                                
                                <h3>Liability for Contents</h3>
                                <p>
                                    The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents' accuracy, completeness or topicality. As service providers, we are liable for own contents of these websites according to § 7, paragraph 1 German Telemedia Act (TMG). However, according to §§ 8 to 10 German Telemedia Act (TMG), service providers are not under obligation to permanently monitor submitted or stored information or to search for evidences that indicate illegal activities. Legal obligations to remove information or to block the use of information remain unchallenged. In this case, liability is only possible at the time of knowledge about a specific violation of law. Illegal contents will be removed immediately at the time we get knowledge of them.
                                </p>

                                <h3>Liability for Links</h3>
                                <p>
                                    Our offer includes links to external third party websites. We have no influence on the contents of those websites, therefore we cannot guarantee for those contents. Providers or administrators of linked websites are always responsible for their own contents. The linked websites had been checked for possible violations of law at the time of the establishment of the link. Illegal contents were not detected at the time of the linking. However, a permanent monitoring of the contents of linked websites cannot be imposed without reasonable indications that there has been a violation of law. Illegal links will be removed immediately at the time we get knowledge of them.
                                </p>

                                <h3>Copyright</h3>
                                <p>
                                    Contents and compilations published on these websites by the providers are subject to German copyright laws. Reproduction, editing, distribution as well as the use of any kind outside the scope of the copyright law require a written permission of the author or originator. Downloads and copies of these websites are permitted for private use only. The commercial use of our contents without permission of the original author is prohibited.
                                </p>
                                <p>
                                    Copyright laws of third parties are respected as long as the contents on these websites do not originate from the provider. Contributions of third parties on this site are indicated as such. However, if you notice any violations of copyright law, please inform us. Such contents will be removed immediately.
                                </p>

                                <h2>Data Protection</h2>
                                <p>
                                    The use of our website is usually possible without providing personal information. As far as personal data (such as name, address or email addresses) is collected on our pages, this is always done on a voluntary basis, as far as possible. This data will not be passed on to third parties without your explicit consent.
                                </p>
                                <p>
                                    We point out that data transmission over the Internet (e.g., when communicating via email) may have security gaps. A complete protection of data against access by third parties is not possible.
                                </p>
                                <p>
                                    The use of contact data published within the framework of the imprint obligation by third parties for sending unsolicited advertising and information materials is hereby expressly prohibited. The operators of the pages expressly reserve the right to take legal action in the event of unsolicited sending of advertising information, such as spam emails.
                                </p>

                                <p className="last-updated">
                                    <em>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</em>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Inprint;

